// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_copyright-module--container--1T0-j","link":"footer_copyright-module--link--356mM"};